import { auth } from '../firebase/firebaseApp';
import { BulkSelectionPayload, BulkGroupLinkRequest, BulkBrochureRequest } from '../server/bulk/bulkTypes';

const BASE_URL = '/api/bulk';

async function getAuthHeaders(contentType = 'application/json', explicitRole?: string): Promise<HeadersInit> {
  const headers: Record<string, string> = {};
  if (contentType) {
    headers['Content-Type'] = contentType;
  }
  try {
    if (explicitRole) {
      headers['x-user-role'] = explicitRole;
    }
    const userStr = localStorage.getItem('auth_user_session');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user?.id || user?.uid) headers['x-user-id'] = user.id || user.uid;
      if (!explicitRole && user?.role) headers['x-user-role'] = user.role;
    }
    const currentUser = auth.currentUser;
    if (currentUser) {
      const token = await currentUser.getIdToken();
      if (token) headers['Authorization'] = `Bearer ${token}`;
    }
  } catch (err) {
    console.warn('[bulkApiClient] Error resolviendo auth headers:', err);
  }
  return headers;
}

function triggerBrowserDownload(blob: Blob, defaultFilename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = defaultFilename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export async function downloadBulkExcelApi(selection: BulkSelectionPayload): Promise<void> {
  const headers = await getAuthHeaders('application/json', selection.userRole);
  const res = await fetch(`${BASE_URL}/excel`, {
    method: 'POST',
    headers,
    body: JSON.stringify(selection),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Error descargando Excel' }));
    throw new Error(err.message || `Error ${res.status}`);
  }
  const blob = await res.blob();
  triggerBrowserDownload(blob, `Inmuebles_${Date.now()}.xlsx`);
}

export async function downloadBulkCsvApi(selection: BulkSelectionPayload): Promise<void> {
  const headers = await getAuthHeaders('application/json', selection.userRole);
  const res = await fetch(`${BASE_URL}/csv`, {
    method: 'POST',
    headers,
    body: JSON.stringify(selection),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Error descargando CSV' }));
    throw new Error(err.message || `Error ${res.status}`);
  }
  const blob = await res.blob();
  triggerBrowserDownload(blob, `Inmuebles_${Date.now()}.csv`);
}

export async function createBulkGroupLinkApi(
  req: BulkGroupLinkRequest
): Promise<{ groupUrl: string; totalMatched: number; processedCount: number }> {
  const headers = await getAuthHeaders('application/json', req.selection?.userRole);
  const res = await fetch(`${BASE_URL}/group-link`, {
    method: 'POST',
    headers,
    body: JSON.stringify(req),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error generando link grupal');
  return data;
}

export async function sendBulkBrochureApi(
  req: BulkBrochureRequest
): Promise<{ success: boolean; message: string; processedCount: number }> {
  const headers = await getAuthHeaders('application/json', req.selection?.userRole);
  const res = await fetch(`${BASE_URL}/brochure`, {
    method: 'POST',
    headers,
    body: JSON.stringify(req),
  });
  const text = await res.text();
  let data: any;
  try {
    data = JSON.parse(text);
  } catch {
    if (res.ok) {
      data = { success: true, message: 'Brochure enviado exitosamente', processedCount: req.selection.selectedIds?.length || 0 };
    } else {
      throw new Error(`Error en servidor (${res.status}): ${text.slice(0, 100)}`);
    }
  }
  if (!data.success) throw new Error(data.message || 'Error enviando brochure');
  return data;
}
